import { useEffect, useRef, useState } from "react";
import { throttle } from "lodash";
import config from "config";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer";
import Icon from "components/Elements/Icon/Icon";
import useMediaQueries from "hooks/useMediaQueries";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import Image from "components/Elements/Image/Image";
import {
  ButtonA,
  ButtonAccessability,
} from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

const MIN_SUPER_WIDE_SCREEN_WIDTH = 1750;

const EnterpriseNotiComponent = () => {
  const { getHtmlByKey, getTextByKey, getPath } = useContent();
  const { mobileCondition } = useMediaQueries();

  const [show, setShow] = useState(
    window.innerWidth > MIN_SUPER_WIDE_SCREEN_WIDTH
  );
  const [isInView, setIsInView] = useState(false);
  const targetRef = useRef<HTMLDivElement>(null);

  const handleShow = () => {
    setShow((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      const target = targetRef.current;
      if (target) {
        const scrollPosition = window.scrollY;
        const viewportHeight = window.innerHeight;
        const pageHeight = document.body.scrollHeight;

        // Define the threshold limits
        const lowerThreshold = viewportHeight - 200; // Screen height
        const upperThreshold = pageHeight - viewportHeight - 300; // Last 200px of full page height

        // Check if scroll position is past the lower threshold but not beyond the upper threshold
        setIsInView(
          scrollPosition > lowerThreshold && scrollPosition < upperThreshold
        );
      }
    };

    const throttleScroll = throttle(() => {
      handleScroll();
    }, 100);

    window.addEventListener("scroll", throttleScroll);

    return () => {
      window.removeEventListener("scroll", throttleScroll);
    };
  }, []);

  return (
    <div ref={targetRef}>
      <AnimationContainer
        animationOn={show && isInView}
        animationClassName={mobileCondition ? "fade-in" : "side-bar-animation"}
      >
        <div className="enterprise-noti-container">
          <ButtonAccessability
            buttonClassName="close-icon"
            onClick={handleShow}
          >
            <Icon name="x" title={getTextByKey("close")} />
          </ButtonAccessability>
          {getHtmlByKey("enterprise-feature-noti-text")}
          <ButtonA
            title={getTextByKey("contact-us")}
            href={`${config.baseurl}${getPath()}contact-us?subject=sales`}
            transparent
          />
        </div>
      </AnimationContainer>
      <AnimationContainer
        animationOn={!show && isInView}
        animationClassName="fade-in"
      >
        <ButtonAccessability
          buttonClassName="enterprise-noti-icon"
          onClick={handleShow}
        >
          <Tooltip tooltipText={getTextByKey("enterprise-noti-tooltip")}>
            <Image name="plans/enterprise" />
          </Tooltip>
        </ButtonAccessability>
      </AnimationContainer>
    </div>
  );
};

export default EnterpriseNotiComponent;
